"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    props: {
        bodyShown: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            toggled: false
        };
    },
    created: function () {
        this.toggled = this.bodyShown;
    },
    methods: {
        toggle: function () { this.toggled = !this.toggled; }
    }
};
